import {SidebarPackages as PackagesComponent} from '@github-ui/code-view-sidebar/components/SidebarPackages'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarPackages({ownerLogin, repoName}: Props) {
  const {packages} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!packages) return null
  return <PackagesComponent {...packages} />
}
